import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Register.css";
import { FormControl, InputLabel, Select, MenuItem, TextField, Grid, Typography } from '@mui/material';
import AccountMasterHelp from "../../../../Helper/AccountMasterHelp";
import ReportButton from "../../../../Common/Buttons/ReportButton";
import Swal from 'sweetalert2';
import { FaDownload } from 'react-icons/fa';

const AllRegisterReport = () => {
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const [selectType, setSelectType] = useState('J');
    const AccountYear = sessionStorage.getItem("Accounting_Year");
    const Year_Code = sessionStorage.getItem("Year_Code");
    const Company_Code = sessionStorage.getItem("Company_Code");

    const [acCode, setAcCode] = useState("");
    const [accoid, setAccoid] = useState("");
    const [acname, setAcname] = useState("");

    const [activeButton, setActiveButton] = useState(null);
    const [awakFilter, setAwakFilter] = useState("WITH");
    const [reportType, setReportType] = useState("PartyWise");



    useEffect(() => {
        const currentDate = new Date().toISOString().split("T")[0];
        setFromDate(currentDate);
        setToDate(currentDate);
    }, []);

    const handleAc_Code = (code, id, name) => {
        setAcCode(code);
        setAccoid(id);
        setAcname(name);
    };

    // const generateReportUrl = (base) => {
    //     return `${base}?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}&Company_Code=${encodeURIComponent(Company_Code)}&Year_Code=${encodeURIComponent(Year_Code)}`;
    // };

    const generateReportUrl = (base, includeSaudaType = false) => {
        let url =
            `${base}?fromDate=${encodeURIComponent(fromDate)}` +
            `&toDate=${encodeURIComponent(toDate)}` +
            `&Company_Code=${encodeURIComponent(Company_Code)}` +
            `&Year_Code=${encodeURIComponent(Year_Code)}`;

        if (includeSaudaType && selectType && selectType !== "All") {
            url += `&Sauda_Type=${encodeURIComponent(selectType)}`;
        }
        if (base === "/advance-report") {
            url += `&Awak_Filter=${encodeURIComponent(awakFilter)}`;
        }

        if (base === "/Date-wiseSaleBill-report" && reportType) {
            url += `&Report_Type=${encodeURIComponent(reportType)}`;
        }

        return url;
    };


    // const handleReportClick = async (label, baseUrl) => {
    //     setActiveButton(label);

    //     let includeSauda = false;

    //     if (label === "Sale Register") {
    //         includeSauda = true;   // <-- Only here we pass Sauda_Type
    //     }


    //     const reportMap = {
    //         "Sale TDS": "/SaleTDSPartyWise-registers",
    //         "Sale TCS": "/SaleTCSPartyWise-registers",
    //         "Purchase TDS": "/PurchaseTDSpartywise-registers",
    //         "Purchase TCS": "/PurchaseTCSpartywise-registers"
    //     };

    //     let finalUrl = generateReportUrl(baseUrl, includeSauda);

    //     if (reportMap[label]) {
    //         const result = await Swal.fire({
    //             title: 'Select Report Type',
    //             text: 'Choose how you want to view the report',
    //             icon: 'question',
    //             showCancelButton: true,
    //             confirmButtonText: 'Summary',
    //             cancelButtonText: 'PartyWise',
    //             reverseButtons: true
    //         });

    //         finalUrl = result.isConfirmed ? baseUrl : reportMap[label];
    //     }

    //     finalUrl = generateReportUrl(finalUrl.split("?")[0]);

    //     setTimeout(() => {
    //         window.open(finalUrl, "_blank", "toolbar=yes,location=yes,status=yes,menubar=yes,scrollbars=yes,resizable=yes,width=800,height=600");
    //         setActiveButton(null);
    //     }, 500);
    // };

    // const handleReportClick = async (label, baseUrl) => {
    //     setActiveButton(label);

    //     let includeSauda = false;
    //     let includeAwakFilter = false;

    //     if (label === "Sale Register") {
    //         includeSauda = true;
    //     }

    //     if (label === "Awak Register") {
    //         includeAwakFilter = true;
    //     }


    //     let finalUrl = generateReportUrl(baseUrl, includeSauda, includeAwakFilter);

    //     const reportMap = {
    //         "Sale TDS": "/SaleTDSPartyWise-registers",
    //         "Sale TCS": "/SaleTCSPartyWise-registers",
    //         "Purchase TDS": "/PurchaseTDSpartywise-registers",
    //         "Purchase TCS": "/PurchaseTCSpartywise-registers"
    //     };

    //     if (reportMap[label]) {
    //         const result = await Swal.fire({
    //             title: 'Select Report Type',
    //             text: 'Choose how you want to view the report',
    //             icon: 'question',
    //             showCancelButton: true,
    //             confirmButtonText: 'Summary',
    //             cancelButtonText: 'PartyWise',
    //             reverseButtons: true
    //         });

    //         const selectedBase = result.isConfirmed ? baseUrl : reportMap[label];
    //         finalUrl = generateReportUrl(selectedBase, includeSauda, includeAwakFilter);
    //     }

    //     window.open(
    //         finalUrl,
    //         "_blank",
    //         "toolbar=yes,location=yes,status=yes,menubar=yes,scrollbars=yes,resizable=yes,width=800,height=600"
    //     );

    //     setActiveButton(null);
    // };

    const handleReportClick = async (label, baseUrl) => {
        setActiveButton(label);

        let includeSauda = false;

        if (label === "Sale Register") {
            includeSauda = true;
        }

        let finalUrl = generateReportUrl(baseUrl, includeSauda);

        const reportMap = {
            "Sale TDS": "/SaleTDSPartyWise-registers",
            "Sale TCS": "/SaleTCSPartyWise-registers",
            "Purchase TDS": "/PurchaseTDSpartywise-registers",
            "Purchase TCS": "/PurchaseTCSpartywise-registers"
        };

        if (reportMap[label]) {
            const result = await Swal.fire({
                title: 'Select Report Type',
                text: 'Choose how you want to view the report',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Summary',
                cancelButtonText: 'PartyWise',
                reverseButtons: true
            });

            const selectedBase = result.isConfirmed ? baseUrl : reportMap[label];
            finalUrl = generateReportUrl(selectedBase, includeSauda);
        }

        window.open(
            finalUrl,
            "_blank",
            "toolbar=yes,location=yes,status=yes,menubar=yes,scrollbars=yes,resizable=yes,width=800,height=600"
        );

        setActiveButton(null);
    };





    return (
        <div className="container" style={{ Width: "100%", padding: "10px" }}>
            <Typography variant="h6"
                component="h1"
                gutterBottom
                sx={{
                    textAlign: 'center',
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                    color: '#2c3e50',
                    marginBottom: '30px',
                    padding: '12px 0',
                    position: 'relative',
                    '&::after': {
                        content: '""',
                        position: 'absolute',
                        bottom: '0',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: '80px',
                        height: '4px',
                        background: 'linear-gradient(90deg, #3498db, #2ecc71)',
                        borderRadius: '2px',
                        animation: 'underlineGrow 0.5s ease-out forwards'
                    },
                    '@keyframes underlineGrow': {
                        '0%': { width: '0' },
                        '100%': { width: '80px' }
                    }
                }}>
                Register
            </Typography>

            {/* <div className="PurchaseSaleregister-row">
                <label htmlFor="AC_CODE" className="PurchaseSaleregisterlabel" style={{ whiteSpace: "nowrap" }}>Account Code:</label>
                <AccountMasterHelp onAcCodeClick={handleAc_Code} name="AC_CODE" CategoryName={acname} CategoryCode={acCode} Ac_type="" />
            </div> */}

            <div className="PurchaseSaleregister-row">
                <label htmlFor="fromDate" className="PurchaseSaleregisterlabel">From Date:</label>
                <input type="date" id="fromDate" className="form-control" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />

                <label htmlFor="toDate" className="PurchaseSaleregisterlabel">To Date:</label>
                <input type="date" id="toDate" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />

                <Grid container spacing={1} alignItems="center" mt={1} >
                    <Grid item xs={12} sm={3}>
                        <FormControl fullWidth>
                            <InputLabel id="selectType-label">Select Type</InputLabel>
                            <Select
                                labelId="selectType-label"
                                id="Sauda_Type"
                                value={selectType}
                                label="Select Type"
                                size='small'
                                onChange={(e) => setSelectType(e.target.value)}
                            >
                                <MenuItem value="All">ALL</MenuItem>
                                <MenuItem value="J">Jaggery</MenuItem>
                                <MenuItem value="T">Turmeric</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>



                    <Grid item xs={12} sm={4}>
                        <FormControl fullWidth>
                            <InputLabel id="sale-filter-label">Sale Bill Filter</InputLabel>
                            <Select
                                labelId="sale-filter-label"
                                value={reportType}
                                label="Sale Bill Filter"
                                size="small"
                                onChange={(e) => setReportType(e.target.value)}
                            >
                                <MenuItem value="PartyWise">Date Wise Sale Register</MenuItem>
                                <MenuItem value="Total">Total Sale Register</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>



                    <Grid item xs={12} sm={3}>
                        <FormControl fullWidth>
                            <InputLabel id="awak-filter-label">Awak Filter</InputLabel>
                            <Select
                                labelId="awak-filter-label"
                                value={awakFilter}
                                label="Awak Filter"
                                size="small"
                                onChange={(e) => setAwakFilter(e.target.value)}
                            >
                                <MenuItem value="WITH">With Awak No</MenuItem>
                                <MenuItem value="WITHOUT">Without Awak No</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>

            </div>



            <div className="grid-container">
                {[
                    { label: "Patti Register", url: "/patti-registers" },
                    { label: "Party Total Amount", url: "/Date-wiseSaleBill-report" },
                    { label: "Advance Report", url: "/advance-report" },
                    // { label: "Sale Bill Cess Report", url: "/Cess-Report" },
                    // { label: "Sale Return Sale", url: "/SaleReturnSale-registers" },
                    // { label: "Purchase Register", url: "/Purchase-registers" },
                    // { label: "Purchase TDS", url: "/PurchaseTDS-registers" },
                    // { label: "Purchase TCS", url: "/PurchaseTCS-registers" },
                    // { label: "Purchase Return", url: "/PurchaseReturn-registers" },
                    // { label: "Mill Sale Report", url: "/MillSaleReport-registers" },
                    // { label: "Sale Month Wise", url: "/SaleMonthWise-registers" },
                    // { label: "Purchase Month Wise", url: "/PurchaseMonthWise-registers" },
                    // { label: "RCM", url: "/RCM-registers" },
                    // { label: "Purchase Analytics", url: "/Detailed_PurchaseRegister" },
                    // {label: "Sale Analytics", url: "/Detailed_SaleRegister" }
                ].map((item, index) => (
                    <ReportButton
                        key={index}
                        label={item.label}
                        icon={FaDownload}
                        loading={activeButton === item.label}
                        disabled={activeButton !== null}
                        onClick={() => handleReportClick(item.label, item.url)}
                    />
                ))}
            </div>
            {error && <div className="alert alert-danger">{error}</div>}
        </div>
    );
};

export default AllRegisterReport;
